import React from 'react'
import { Trans, t } from '@lingui/macro'
import IconBubble from '../../../components/common/icon/IconBubble'
import BorderedBox, {
  BorderedBoxStats
} from '../../../components/common/bordered-box/BorderedBox'
import { stripHTMLTags } from '../../../../../shared/HTML'
import './CampaignAction.less'
import { CampaignActionControls } from './commonComponents'
import { CampaignMessageActionModelAsEditor } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { campaignMessageTypeLabel } from '../common'

const CampaignMessageAction = ({
  message,
  onEditClick,
  onDeleteClick,
  onCopyClick
}: {
  message: CampaignMessageActionModelAsEditor
  onEditClick: (e: React.MouseEvent<HTMLSpanElement>) => void
  onDeleteClick: (e: React.MouseEvent<HTMLSpanElement>) => void
  onCopyClick: (e: React.MouseEvent<HTMLSpanElement>) => void
}) => {
  const hasData = !!message.sentCount
  const subject = stripHTMLTags(message.text)
  const sentCount = message.sentCount || 0
  const failedCount = message.failedCount || 0

  return (
    <BorderedBox className="CampaignAction">
      <div className="CampaignAction__icon">
        <IconBubble />
      </div>
      <div className="CampaignAction__desc">
        <span>
          <b>
            <Trans>
              Send {campaignMessageTypeLabel(message.type!)} message
            </Trans>
            :
          </b>{' '}
          <i>
            {subject.substring(0, 20)}
            {subject.length > 20 ? '...' : ''}
          </i>
        </span>
      </div>

      <CampaignActionControls
        onEditClick={onEditClick}
        onDeleteClick={onDeleteClick}
        onCopyClick={onCopyClick}
      />

      <BorderedBoxStats
        stats={[
          {
            className: 'sent',
            caption: t`Sent`,
            value: message.sentCount || (hasData && '0') || '-'
          },
          {
            className: 'failed',
            caption: t`Failed`,
            value: message.failedCount || (hasData && '0') || '-'
          },
          {
            className: 'effectiveness',
            caption: t`Effectiveness`,
            value:
              (hasData &&
                `${Math.min(
                  Math.ceil(((sentCount - failedCount) / sentCount) * 100),
                  100
                )}%`) ||
              '-'
          }
        ]}
      />
    </BorderedBox>
  )
}

export default CampaignMessageAction
